import { render, staticRenderFns } from "./UploadImagensCarrosselDialog.vue?vue&type=template&id=3f50edf2&"
import script from "./UploadImagensCarrosselDialog.vue?vue&type=script&lang=js&"
export * from "./UploadImagensCarrosselDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagensCarrosselDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports